import { render, staticRenderFns } from "./TableSection.vue?vue&type=template&id=5a67df34&scoped=true"
import script from "./TableSection.vue?vue&type=script&lang=js"
export * from "./TableSection.vue?vue&type=script&lang=js"
import style0 from "./TableSection.vue?vue&type=style&index=0&id=5a67df34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67df34",
  null
  
)

export default component.exports